export default __webpack_public_path__ + "static/homeBgMb-39c6f727da15a21b2bc856a4c1c82909.png";